export default __webpack_public_path__ + "static/media/216onefloorplan.75a8f672.svg";